import { cpus } from 'os';
export class JsonLoader {
    url: string;
    param: object;
    body: string;
    useCookie: boolean;
    credentials: string;
    mode: string;
    timeout: number = 100000;
    method: string = 'POST'
    constructor(url?: string, param?: object) {
        this.url = url;
        this.param = param;
        this.useCookie = false;
    }
    setURL = (url: string): void => {
        this.url = url;
    }
    setMethod = (method: string) => {
        this.method = method;
    }
    setParam = (param: object): void => {
        this.param = param;
    }
    setUseCookie = (flag: boolean): void => {
        this.useCookie = flag;
    }
    load = (): Promise<object> => {
        const loadFunc = new Promise((resolve, reject) => {
            const options = this.getOptions();
            // console.log(this.url);
            if (this.method === 'GET') {
                if (this.param) {
                    const param = Object.keys(this.param)
                        .filter((key) => this.param[key] !== undefined)
                        .map((key) => key + "=" + encodeURIComponent(this.param[key])).join("&");
                    console.log(this.url)
                    this.url += "?" + param;
                }
            }

            fetch(this.url, options)
                .then(response => {
                    // console.log(response);
                    return response.json();
                }).then(json => {
                    const obj = JSON.parse(JSON.stringify(json));
                    // console.log("---------------------------------------------------------------------------------");
                    // console.log(this.url);
                    // console.info(obj);
                    // console.log("---------------------------------------------------------------------------------");
                    resolve(JSON.parse(JSON.stringify(json)));
                }).catch(reason => {
                    reject(reason);
                })

        });

        const timeoutFunc = new Promise((_resolve, reject) => {
            setTimeout(() => {
                reject(new Error('TIMEOUT'));
            }, this.timeout);
        });

        return new Promise((resolve, reject) => {
            Promise.race([
                loadFunc,
                timeoutFunc
            ]).then(value => {
                resolve(<object>value);
            }).catch(reason => {
                // console.log(reason);
                reject(reason);
                // throw new Error(reason + ":" + this.url);
            })
        })
    }

    getOptions = () => {
        let options: RequestInit = {
            // credentials : 'include',
            cache: <RequestCache>'no-cache',
            redirect: <RequestRedirect>'follow', // manual, *follow, error
            /*
            defaultHeaders: {
                'If-Modified-Since': 'Thu, 01 Jun 1970 00:00:00 GMT'
            },
            */
            headers: {
                'Accept': 'application/json; charset=utf-8',
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            method: this.method, // *GET, POST, PUT, DELETE, etc.
            // credentials: <RequestCredentials>'omit',
            //mode: <RequestMode>'same-origin'
        }
        if (this.param && this.method == 'POST') {
            options.body = Object.keys(this.param)
                .filter((key) => this.param[key] !== undefined)
                .map((key) => key + "=" + encodeURIComponent(this.param[key])).join("&");
            // console.log(this.param);
            // console.log(options.body);
        }
        if (this.useCookie) {
            options.credentials = 'include';
            options.mode = 'cors';
        }

        return options;
    }
}
